"use client";

import { c as _c } from "react/compiler-runtime";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { COMMAND_PRIORITY_LOW, PASTE_COMMAND, $getSelection, $isRangeSelection } from "lexical";
import { useEffect } from "react";
const TEXT_MIME_TYPE = "text/plain";
export default function PlainTextPastePlugin() {
  const $ = _c(3);
  const [editor] = useLexicalComposerContext();
  let t0;
  let t1;
  if ($[0] !== editor) {
    t0 = () => editor.registerCommand(PASTE_COMMAND, event => {
      const clipboardData = event.clipboardData;
      if (!clipboardData) {
        return false;
      }
      if (clipboardData.files.length > 0) {
        return false;
      }
      const text = clipboardData.getData(TEXT_MIME_TYPE);
      if (!text.length) {
        return false;
      }
      event.preventDefault();
      editor.update(() => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
          selection.insertRawText(text);
        }
      });
      return true;
    }, COMMAND_PRIORITY_LOW);
    t1 = [editor];
    $[0] = editor;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}